module.exports = __webpack_public_path__ + "media/images/icon__point--default@2x-223d19983c9ca00d2a52bca708ceae5b.png";